<template>
  <el-upload
    :action="uploadActionUrl"
    :headers="headers"
    :on-error="uploadError"
    :on-success="uploadSuccess"
    :show-file-list="false"
  >
    <el-button icon="el-icon-document-add" type="primary">
      インポート'
    </el-button>
  </el-upload>
</template>

<script>
  import store from '@/store'
  import { baseURL } from '@/config/net.config'

  export default {
    name: 'VabSimpleUpload',
    props: {
      uploadUrl: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        uploadActionUrl: baseURL + this.uploadUrl,
      }
    },
    computed: {
      headers() {
        return {
          Authorization: `Bearer ${store.getters['user/accessToken']}`,
        }
      },
    },
    methods: {
      uploadSuccess() {
        this.$emit('on-success')
        this.$baseNotify('操作が成功しました')
      },
      uploadError(err) {
        const result = JSON.parse(err.message)
        this.$baseNotify(result.error, null, 'error')
      },
    },
  }
</script>
